import { AgentNodeDataSchema, ResourceType } from '@cotera/api';
import type { WorkflowNodeData } from '../types';
import type {
  WorkflowNodeHydration,
  WorkflowNodeResourceRef,
} from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { nonBlank } from './output-shape-helpers';
import { TypedWorkflowNode } from './typed-workflow-node';

export class AgentWorkflowNode extends TypedWorkflowNode<
  typeof AgentNodeDataSchema
> {
  protected readonly schema = AgentNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): AgentWorkflowNode {
    return new AgentWorkflowNode(data, hydration);
  }
  override deriveTypedOutputShape(
    context: WorkflowNodeOutputShapeContext
  ): string | null {
    const agentId = nonBlank(this.config?.agentId);
    if (agentId === undefined) {
      return null;
    }
    return context.resolveAgentOutputShape(agentId);
  }

  override resourceRefs(): readonly WorkflowNodeResourceRef[] {
    const agentId = nonBlank(this.config?.agentId);
    return agentId === undefined
      ? []
      : [{ type: ResourceType.Agent, id: agentId, field: 'agentId' }];
  }

  protected override defaultDisplayName(): string {
    const agentId = nonBlank(this.config?.agentId);
    return agentId === undefined ? 'Agent' : `Agent ${agentId.slice(0, 8)}…`;
  }
}
